<div class="page-container">
    <app-certification-approver-list></app-certification-approver-list>
</div>